
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import projectData from "../../../data/innerpages/single_project/projectData.json";

function ProjectDetailPage() {

 const { slug } = useParams();

  const project = projectData.projects.find(
    (item) => item.slug === slug
  );

   
 const [currentSlide, setCurrentSlide] = useState(0);
  // If Project Not Found
  if (!project) {
    return <h2>Project Not Found</h2>;
  }

  const {
    title,
    location,
    bannerImage,
    descTitle,
    description,
    projectImages,
  } = project;


  // Next Slide
  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === projectImages.length - 1 ? 0 : prev + 1
    );
  };

  // Previous Slide
  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? projectImages.length - 1 : prev - 1
    );
  };

  // Auto Slider
  useEffect(() => {
    const autoSlider = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(autoSlider);
  }, [currentSlide]);

  return (
    <div className="project-detail-page">

      {/* Banner */}
      <section
        className="project-banner"
        style={{
          backgroundImage: `url(${bannerImage})`,
        }}
      >
        <div className="overlay">
          <div className="container">
            <div className="banner-content text-center">
              <h1>{title}</h1>
              <p>{location}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="project-content project-page-section-padding">
        <div className="container">

          <div className="project-info-row">

            {/* Left */}
            <div className="project-left">
              <h2>
  {descTitle.split(" | ")[0]}
  <br />
   {descTitle.split(" | ")[1]}
</h2>
            </div>

            {/* Right */}
            <div className="project-right">
              {description.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </div>

          </div>

          {/* Slider */}
          <div className="project-slider">

            <button className="nav-btn left" onClick={prevSlide}>
              <FaChevronLeft />
            </button>

            <div className="slider-image">
              <img
                src={projectImages[currentSlide]}
                alt={descTitle}
              />
            </div>

            <button className="nav-btn right" onClick={nextSlide}>
              <FaChevronRight />
            </button>

          </div>

        </div>
      </section>

    </div>
  );
}

export default ProjectDetailPage;